import { StudentNameCell } from '@/components/student/tables/cells';
import { SmartTableCellProps } from '@/components/ui/daisy';

import { ActivityProgress } from '@/models/ActivityProgress';

export default function StudentCell({
  item,
}: SmartTableCellProps<Pick<ActivityProgress, 'student'>>) {
  const { student } = item;

  if (!student) return null;

  return <StudentNameCell item={student} />;
}
